module.exports = __webpack_public_path__ + "img/37.d4b0f53f.jpg";